import {
	KYCAuthorizationOriginSourceEnum,
	KYCAuthorizationProductSourceTypeEnum,
} from '.spec/self-care/tsTypes';
import { Button, Heading, Text } from '@mallpay/orbis';
import React, { useState } from 'react';

import { ReactComponent as IconCheck } from '@skippay/core/assets/icons/icon-check-circle-filled.svg';
import { useGoogleAnalytics, usePageview } from '@skippay/core/components/GoogleAnalytics';
import Redirect from '@skippay/core/components/Redirect';
import { FormattedMessage } from '@skippay/core/i18n/intl';

import { KYC_VERIFICATION, OVERVIEW } from 'constants/routes';
import { FooterButtons } from 'layout/MinimalLayout/components/FooterButtons';

import { GA_ECAT } from '../../constants';
import { BnplLimitSetupApplication } from '../../types';

type RedirectTarget = 'identityVerify' | 'verifyLater';

interface Props {
	applicationId: BnplLimitSetupApplication['id'];
}

function KycRequired({ applicationId }: Props): JSX.Element {
	const { sendEvent } = useGoogleAnalytics();
	const [redirectTo, setRedirectTo] = useState<RedirectTarget | undefined>(undefined);
	usePageview({ pTitle: 'bnpl_limit_management_kyc_required' });

	if (redirectTo === 'identityVerify') {
		return (
			<Redirect
				to={{
					pathname: KYC_VERIFICATION,
					query: {
						source: KYCAuthorizationOriginSourceEnum.BNPL_LIMITS_APPLICATION,
						productType: KYCAuthorizationProductSourceTypeEnum.BNPL_LIMITS_APPLICATION,
						id: applicationId,
					},
				}}
			/>
		);
	}

	if (redirectTo === 'verifyLater') {
		return <Redirect to={OVERVIEW} />;
	}

	return (
		<section className="mx-auto px-4 pt-6 pb-8">
			<div className="flex flex-col gap-8 pb-8">
				<Text as="div" className="text-center">
					<IconCheck className="h-20 w-20" />
				</Text>

				<div className="flex flex-col gap-3">
					<Heading as="h1" className="text-center">
						<FormattedMessage
							id="BnplLimitManagement.KycRequired.title"
							defaultMessage="Limit máte předschválený"
						/>
					</Heading>

					<div className="mt-4">
						<Text as="div" className="text-center">
							<FormattedMessage
								id="BnplLimitManagement.KycRequired.description"
								defaultMessage="Pro konečné schválení je ještě potřeba ověřit vaši totožnost. To můžete udělat rovnou, nebo nejpozději před první platbou z Limitu"
							/>
						</Text>
					</div>
				</div>
			</div>

			<FooterButtons
				content={
					<Button
						testId="bnplVerifyIdentity"
						analyticsParam="bnplVerifyIdentity"
						variant="primary"
						onClick={() => {
							sendEvent({ eCat: GA_ECAT, eAct: 'KYC', eLab: 'Identity Verify' });
							setRedirectTo('identityVerify');
						}}
						className="mx-auto!"
					>
						<FormattedMessage
							id="BnplLimitManagement.KycRequired.verifyIdentity"
							defaultMessage="Ověřit se"
						/>
					</Button>
				}
			/>
		</section>
	);
}

export default KycRequired;
